import { createContext, useContext } from 'react';
import { mapKeys, snakeCase } from 'lodash';
export function keysToSnakeCase(obj) {
    if (!obj) return {};
    return mapKeys(obj, (_value, key)=>snakeCase(key));
}
export const BiContext = createContext(()=>null);
export function useBiContextGetter() {
    return useContext(BiContext);
}
